module.exports = __webpack_public_path__ + "img/bocBoa.fc45dd93.png";